<template>
  <v-row class="mb-6" justify="center" no-gutters>
    <v-col cols="12">
      <!-- CALHN Rates -->
      <v-row justify="center" align="center" class="blue lighten-5">
        <v-col class="text-center">
          <h4>Core (ALL staff) CALHN Mandatory Training Completion Rates</h4>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" class="blue lighten-5">
        <v-col
          class="text-center subtitle-2"
          :class="trafficLights(calhnOneOff)"
          style="margin-left:10px;margin-right:10px;"
        >
          <strong>One-off: {{calhnOneOff}}%</strong>
        </v-col>
        <v-col
          class="text-center subtitle-2"
          :class="trafficLights(calhnOneOff)"
          style="margin-left:10px;margin-right:10px;"
        >
          <strong>On-going: {{calhnOnGoing}}%</strong>
        </v-col>
      </v-row>

      <!-- Chart Buttons Menu -->
      <v-row justify="center" align="center" class="blue lighten-5">
        <v-col class="text-center">
          <v-btn-toggle v-model="isAllPrograms">
            <v-btn small>Programs by Report Date Charts</v-btn>
            <v-btn small>ALL Programs Chart</v-btn>
          </v-btn-toggle>
          <p>
            [
            <a href="./data/prod_calhn_rates_courses.csv" target="_blank">download datafile (csv)</a> ]
          </p>
        </v-col>
      </v-row>

      <transition name="slide">
        <div v-show="!isAllPrograms">
          <!-- Report Buttons -->
          <v-row justify="center" align="center">
            <v-col class="text-center">
              <h4>Program Calculated Completion Rates by Report Date</h4>
            </v-col>
          </v-row>
          <v-row justify="space-around" align="center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div class="text-center subtitle-2" v-on="on">
                  <v-btn
                    x-small
                    color="red"
                    dark
                    v-on:click="selectedDate = worst.dateloaded, selectedProgram = worst.program"
                  >Worst LM</v-btn>
                </div>
              </template>
              <span>The lowest combined calculated completion rates for the last month</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div class="text-center subtitle-2" v-on="on">
                  <v-btn
                    x-small
                    color="primary"
                    dark
                    v-on:click="selectedDate = improvedYTD.dateloaded, selectedProgram = improvedYTD.program"
                  >Most Improved YTD</v-btn>
                </div>
              </template>
              <span>The highest calculated completion rate increase for the year</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div class="text-center subtitle-2" v-on="on">
                  <v-btn
                    x-small
                    color="primary"
                    dark
                    v-on:click="selectedDate = improvedLM.dateloaded, selectedProgram = improvedLM.program"
                  >Most Improved LM</v-btn>
                </div>
              </template>
              <span>The highest calculated completion rate increase for the last month</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div class="text-center subtitle-2" v-on="on">
                  <v-btn
                    x-small
                    color="green darken-2"
                    dark
                    v-on:click="selectedDate = best.dateloaded, selectedProgram = best.program"
                  >Best YTD</v-btn>
                </div>
              </template>
              <span>The highest combined calculated completion rates for the year</span>
            </v-tooltip>
          </v-row>
          <!-- Program Selectors -->
          <v-row>
            <v-col>
              <v-select
                v-model="selectedProgram"
                :items="programs"
                item-text="programs"
                item-value="programs"
                menu-props="auto"
                label="Select a CALHN program"
                prepend-icon="mdi-hospital-building"
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                v-model="selectedDate"
                :items="filteredDates"
                item-text="dateformatted"
                item-value="dateloaded"
                menu-props="auto"
                label="Select a report date"
                prepend-icon="mdi-calendar"
              ></v-select>
              <!-- <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="selectedDate"
                    label="Select a report date"
                    prepend-icon="mdi-calendar"
                    persistent-hint
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="selectedDate" type="month" no-title @input="menu2 = false"></v-date-picker>
              </v-menu> -->
            </v-col>
          </v-row>
          <!-- Program Progress -->
          <v-row justify="center" align="center">
            <v-col class="text-center">
              <h4>
                {{selectedProgram}}
                <br />
                Calculated Completion Rates, ending {{formatDate(selectedDate)}}
              </h4>
            </v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col class="text-center">
              <div class="teal circleText">One-off courses</div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div class="text-center" v-on="on">
                    <v-progress-circular
                      v-if="filteredStats[0]"
                      rotate="270"
                      size="80"
                      :value="filteredStats[0].oneoff"
                      width="15"
                      :color="trafficLights(filteredStats[0].oneoff)"
                    >{{ filteredStats[0].oneoff }}%</v-progress-circular>
                  </div>
                </template>
                <span>{{selectedProgram}} courses that are required to be completed once.</span>
              </v-tooltip>
            </v-col>
            <v-col class="text-center">
              <div class="blue circleText">On-going certifications</div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div class="text-center" v-on="on">
                    <v-progress-circular
                      v-if="filteredStats[0]"
                      rotate="270"
                      size="80"
                      :value="filteredStats[0].ongoing"
                      width="15"
                      :color="trafficLights(filteredStats[0].ongoing)"
                    >{{ filteredStats[0].ongoing }}%</v-progress-circular>
                  </div>
                </template>
                <span>{{selectedProgram}} certifications that are required to be completed on a recurring schedule.</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col class="text-center">
              <line-chart v-if="chartdata" :chart-data="chartdata"></line-chart>
            </v-col>
          </v-row>
        </div>
        {{lastName}}
      </transition>

      <transition name="slide">
        <div v-show="isAllPrograms">
          <v-row justify="center">
            <v-col class="text-center">
              <h4>
                ALL PROGRAMS
                <br />
                Calculated Completion Rates, ending {{formatDate(maxDate)}}
              </h4>
              <horiz-bar-chart
                v-if="barchartdata"
                :chart-data="barchartdata"
                :options="horizOptions"
              ></horiz-bar-chart>
            </v-col>
          </v-row>
        </div>
      </transition>
    </v-col>
  </v-row>
</template>

<script>
import * as d3 from "d3-fetch";
import moment from "moment";
import LineChart from "@/charts/LineChart.js";
import HorizBarChart from "@/charts/HorizBarChart.js";

const STATSFILE = "/data/prod_calhn_rates_courses.csv";

export default {
  components: {
    LineChart,
    HorizBarChart
  },
  watch: {
    selectedProgram: function() {
      this.applyFilters();
    },
    selectedDate: function() {
      this.applyFilters();
    }
  },

  data: () => ({
    lastName: "",
    name: "",
    isAllPrograms: 0,
    // toggle_charts: undefined,
    stats: null,
    selectedDate: null,
    maxDate: null,
    programs: [],
    selectedProgram: "ACUTE & URGENT CARE",
    filteredDates: [],
    filteredStats: [],
    chartdata: {},
    barchartdata: {},
    lblDates: [],
    best: null,
    worst: null,
    improvedYTD: null,
    improvedLM: null,
    calhnOneOff: null,
    calhnOnGoing: null,
    horizOptions: {
      scales: {
        xAxes: [
          {
            ticks: {
              beginAtZero: true,
              suggestedMax: 90
            }
          }
        ]
      },
      plugins: {
        datalabels: {
          backgroundColor: function(context) {
            return context.dataset.backgroundColor;
          },
          align: "end",
          anchor: "end",
          color: "white",
          padding: 2,
          font: {
            size: 10,
            weight: "bold"
          }
        }
      },
      annotation: {
        annotations: [
          {
            type: "line",
            mode: "vertical",
            scaleID: "x-axis-0",
            value: 75,
            borderColor: "red",
            borderWidth: 2,
            borderDash: [2, 2],
            label: {
              // Background color of label, default below
              backgroundColor: "rgb(255, 99, 132)",
              // Font family of text, inherits from global
              fontFamily: "sans-serif",
              // Font size of text, inherits from global
              fontSize: 10,
              // Font style of text, default below
              fontStyle: "bold",
              // Font color of text, default below
              fontColor: "#fff",
              // Padding of label to add left/right, default below
              xPadding: 6,
              // Padding of label to add top/bottom, default below
              yPadding: 6,
              // Radius of label rectangle, default below
              cornerRadius: 6,
              // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
              // position: "left",
              // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
              // For horizontal lines positioned left or right, negative values move
              // the label toward the edge, and positive values toward the center.
              xAdjust: 0,
              // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
              // For vertical lines positioned top or bottom, negative values move
              // the label toward the edge, and positive values toward the center.
              yAdjust: 0,
              // Whether the label is enabled and should be displayed
              enabled: true,
              // Text to display in label - default is null
              content: null
            }
          },
          {
            type: "line",
            mode: "vertical",
            scaleID: "x-axis-0",
            value: 50,
            borderColor: "red",
            borderWidth: 2,
            borderDash: [2, 2],
            label: {
              // Background color of label, default below
              backgroundColor: "rgb(255, 99, 132)",
              // Font family of text, inherits from global
              fontFamily: "sans-serif",
              // Font size of text, inherits from global
              fontSize: 10,
              // Font style of text, default below
              fontStyle: "bold",
              // Font color of text, default below
              fontColor: "#fff",
              // Padding of label to add left/right, default below
              xPadding: 6,
              // Padding of label to add top/bottom, default below
              yPadding: 6,
              // Radius of label rectangle, default below
              cornerRadius: 6,
              // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
              // position: "left",
              // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
              // For horizontal lines positioned left or right, negative values move
              // the label toward the edge, and positive values toward the center.
              xAdjust: 0,
              // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
              // For vertical lines positioned top or bottom, negative values move
              // the label toward the edge, and positive values toward the center.
              yAdjust: 0,
              // Whether the label is enabled and should be displayed
              enabled: true,
              // Text to display in label - default is null
              content: null
            }
          }
        ]
      },
      legend: {
        display: true,
        position: "top",
        fullWidth: true,
        align: "center",
        labels: {
          boxWidth: 10
        }
      },
      responsive: true,
      maintainAspectRatio: true
    }
  }),
  created() {
    this.getStats();
  },
  methods: {
    trafficLights(ratio) {
      if (ratio <= 15) {
        return "red";
      } else if (ratio > 15 && ratio <= 50) {
        return "orange";
      } else if (ratio > 50) {
        return "green darken-2";
      }
    },
    // returns a array with distinct objects based on param
    unique(array, propertyName) {
      return array.filter(
        (e, i) =>
          array.findIndex(a => a[propertyName] === e[propertyName]) === i
      );
    },
    formatDate(date) {
      // correct dates to be prior month and format
      return moment(date)
        .subtract(1, "month")
        .format("MMMM YYYY");
    },
    applyFilters() {
      // show only the dates that match the program
      this.filteredDates = this.stats
        .filter(date => {
          return date.program.match(this.selectedProgram);
        })
        .sort((a, b) => (a.dateloaded > b.dateloaded ? 1 : -1));
      // filter the stats object
      this.filteredStats = this.stats.filter(stat => {
        return (
          stat.program.match(this.selectedProgram) &&
          stat.dateloaded.match(this.selectedDate)
        );
      });

      // generate the dynamic chart data for the program line chart
      this.chartdata = {
        labels: [
          ...new Set(
            this.filteredDates
              .sort((a, b) => (a.dateloaded > b.dateloaded ? 1 : -1))
              .map(item => item.dateformatted)
          )
        ],
        datasets: [
          {
            label: "One-off courses",
            backgroundColor: "rgba(0, 150, 136, 0.8)",
            borderColor: "rgb(0, 150, 136)",
            borderWidth: 2,
            fill: false,
            // Data for the x-axis of the chart
            data: this.filteredDates
              .sort((a, b) => (a.dateloaded > b.dateloaded ? 1 : -1))
              .map(item => item.oneoff)
          },
          {
            label: "On-going certifications",
            backgroundColor: "rgba(33, 150, 243, 0.8)",
            borderColor: "rgb(33, 150, 243)",
            borderWidth: 2,
            fill: false,
            // Data for the x-axis of the chart
            data: this.filteredDates
              .sort((a, b) => (a.dateloaded > b.dateloaded ? 1 : -1))
              .map(item => item.ongoing)
          }
        ]
      };
    },
    getStats() {
      d3.csv(STATSFILE)
        .then(data => {
          // add some derived and formatted data to our stats object loaded from the CSV
          this.stats = data.map(el => ({
            dateformatted: this.formatDate(el.dateloaded),
            sumrates: +el.oneoff + +el.ongoing,
            ...el
          }));
          //.sort((a, b) => (a.dateloaded > b.dateloaded ? 1 : -1));
          //get the distinct programs array for the select list
          this.programs = [...new Set(data.map(item => item.program))].sort();
          // default latest date value
          this.selectedDate = this.stats
            .map(item => item.dateloaded)
            .sort()
            .reverse()[0];
          const latestStats = this.stats.filter(
            item => item.dateloaded == this.selectedDate
          );
          // latest date for report title
          this.maxDate = latestStats[0].dateloaded;

          // console.log(latestStats
          //         .sort((a, b) => (a.program > b.program ? 1 : -1))
          //         .map(item => item.program));
          let sortedLatestStats = latestStats.sort((a, b) =>
            a.program > b.program ? 1 : -1
          );

          // generate the chart data for the programs bar chart
          this.barchartdata = {
            // must be latest programs
            labels: sortedLatestStats.map(item => item.program),
            datasets: [
              {
                label: "One-off courses",
                backgroundColor: "rgba(0, 150, 136, 0.7)",
                borderColor: "rgb(0, 150, 136)",
                borderWidth: 2,
                borderSkipped: "bottom",
                barPercentage: 1.0,
                categoryPercentage: 0.9,
                barThickness: "flex",
                minBarLength: 2,

                // Data for the x-axis of the chart
                data: sortedLatestStats.map(item => item.oneoff)
              },
              {
                label: "On-going certifications",
                backgroundColor: "rgba(33, 150, 243, 0.7)",
                borderColor: "rgb(33, 150, 243)",
                borderWidth: 2,
                borderSkipped: "top",
                barPercentage: 1.0,
                categoryPercentage: 0.9,
                barThickness: "flex",
                minBarLength: 2,

                // Data for the x-axis of the chart
                data: sortedLatestStats.map(item => item.ongoing)
              }
            ]
          };
          // get the best, worst and most improved objects
          // the best over all report dates
          this.best = this.stats.sort((a, b) =>
            a.sumrates > b.sumrates ? -1 : 1
          )[0];

          // the worst only from latest month
          //this.worst = this.stats.sort((a, b) => (a.sumrates > b.sumrates ? 1 : -1))[0];
          this.worst = latestStats.sort((a, b) =>
            a.sumrates > b.sumrates ? 1 : -1
          )[0];

          // calculate the current CALHN completion rates
          let oneoffSum = 0;
          let ongoingSum = 0;
          let i = 0;

          // this.stats
          //   .filter(item => item.dateloaded == this.selectedDate)

          latestStats.forEach(obj => {
            oneoffSum += +obj.oneoff;
            ongoingSum += +obj.ongoing;
            i++;
          });
          this.calhnOneOff = Math.round(oneoffSum / i);
          this.calhnOnGoing = Math.round(ongoingSum / i);

          // Calculate the most improved program object
          let factorYTD = 0;
          let factorLM = 0;

          this.programs.forEach(el => {
            // filter by program and earliest date is first
            let prog = this.stats
              .filter(item => item.program == el)
              .sort((a, b) => (a.dateloaded > b.dateloaded ? 1 : -1));
            // last record minus first record
            let ytd = 1;
            let lm = 1;
            //console.log(prog[0].program, prog[prog.length - 1].sumrates - prog[prog.length - 2].sumrates )
            if (prog.length > 1) {
              ytd = prog[prog.length - 1].sumrates - prog[0].sumrates;
              // last record minus previous record (last month)
              lm =
                prog[prog.length - 1].sumrates - prog[prog.length - 2].sumrates;
            }
            if (ytd > factorYTD) {
              factorYTD = ytd;
              // load latest record
              this.improvedYTD = prog[0];
            }
            if (lm > factorLM) {
              factorLM = lm;
              // load latest record
              this.improvedLM = prog[0];
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.circleText {
  font-size: 80%;
  color: white;
  padding: 4px;
  margin-bottom: 4px;
  font-weight: 500;
}
/* animation */
.slide-enter-active,
.slide-leave-active {
  transition: margin-bottom 0.5s ease-out;
}

/*
you set the css property before transition starts
*/
.slide-enter,
.slide-leave-to {
  margin-bottom: -200px;
}

/*
you set the css property it will be when transition ends
*/
.slide-enter-to,
.slide-leave {
  margin-bottom: 0px;
}
</style>